define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/store/Nodes",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Writer",
	"./SelectQuoteForm"
], function(declare,lang,_,Controller,comm,PostRequest,Nodes,ActionControllerMixin,xml,Writer) {

	var PAGE_IDS = {
		1: "LinkedPartMaterials",
		2: "UnlinkedCostMaterials",
		3: "UnlinkedPartMaterials"
	};

	var _Store = declare(Nodes, {
		controller: null,
		pageIndex: null,

		_createQueryRequest: function(/*Object?*/query, /*Object?*/options) {
			// summary: update result urls from controller
			this.resultUrls = this.controller.getMappingUrls(this.pageIndex);
			this._total = this.resultUrls.length;
			this._bSuppressRequest = true;
			this._loaded = true;

			// set options to use cache
			options = options || {};
			options.useCache = true;

			return this.inherited(arguments);
		}
	});

	return declare([Controller, ActionControllerMixin], {
		idWizardResource: "UpdateFromCostScenarioWizard",
		mappingReportNode: null,

		getBOMRevisionUrl: function() {
			return this.m_urlParent;
		},

		getMappingUrls: function(/*Number*/pageIndex) {
			// summary: return list of urls from mapping report node for the given page index
			return this.mappingReportNode ? this.mappingReportNode[PAGE_IDS[pageIndex]] : [];
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/currentPage, /*csi.wizard.Content*/nextPage, /*Boolean*/bFinish) {
			// S12318: BOM action to pull data from Cost Scenario
			var self = this;
			var fd = this.m_formData;
			var pageIndex = wizard.getIndexOfPage(nextPage);
			var viewParams;
			var dfd;

			// query server for temporary report node with 3 collections once SupplierItem is selected on first page:
			// 		PartMaterials that are linked to CostMaterials (the attribute UpdateFromCostMaterial will contain the linked Cost Material)
			// 		unlinked CostMaterials (those that have no matching PartMaterial)
			// 		unlinked PartMaterials (those that have no matching CostMaterial)
			if (pageIndex == 1) {
				this.mappingReportNode = null;

				var request = new PostRequest("ProductSpec", "GetCostScenarioBOMMappingReport")
					.addParameter("SupplierItem", fd.getFieldValue("SupplierItem"))
					.addParameter("URL", this.getBOMRevisionUrl());

				dfd = this.when(request.go(), function(response) {
					self.mappingReportNode = response.getResultNode();
				});
			}

			if (bFinish) {
				return dfd;
			}

			// fill view parameters for use in last 3 pages
			if (pageIndex && nextPage && !nextPage.viewTab) {
				viewParams = {
					bSupportsQuerySettings: false,
					querySizeFixed: true,
					onCreateMainQueryLevel: function(ql) {
					    ql.storeClass = _Store;
					    ql.storeOptions = {pageIndex: pageIndex, controller: self};
					}
				};
			}

			return this.when(dfd, function() {
				wizard.setFormDataToPage(nextPage, fd, !!pageIndex, viewParams);
			});
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// TA30746: Enable "Finish" button early if following screens will be empty.
			if (index == 1) {
				return this.getMappingUrls(3).length || this.getMappingUrls(2).length;
			} else if (index == 2) {
				return this.getMappingUrls(3).length;
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * clear out of sync flags on close
		 */
		closeDialog: function() {
			new PostRequest("ProductSpec", "ClearOutOfSyncFlags").addParameter("URL", this.getBOMRevisionUrl()).post({});
			this.inherited(arguments);
		},

		/**
		 * @override
		 * clear out of sync flags on cancel
		 */
		_onCancelPopup: function() {
			new PostRequest("ProductSpec", "ClearOutOfSyncFlags").addParameter("URL", this.getBOMRevisionUrl()).post({});
			this.inherited(arguments);
		},

		process: function() {
			// summary: issue request so as to be able to receive return value
			var fd = this.m_formData;
			var req = this.m_action.m_request;
			var value = fd.getSelectedValue();
			var partMaterialsToUpdate = _.intersection(value, this.getMappingUrls(1));
			var costMaterialsToAdd = _.intersection(value, this.getMappingUrls(2));
			var partMaterialsToDelete = _.intersection(value, this.getMappingUrls(3));

			this.setProgress();

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("SupplierItem", fd.getFieldValue("SupplierItem"))
				.addParameter("URL", this.getBOMRevisionUrl())
				.addParameter("PartMaterialsToUpdate", partMaterialsToUpdate)
				.addParameter("CostMaterialsToAdd", costMaterialsToAdd)
				.addParameter("PartMaterialsToDelete", partMaterialsToDelete)
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});